<template>
    <b-row>
        <b-col>
            <b-button-toolbar>
                <b-button-group class="mb-3" size="sm">
                    <b-button v-if="showPrint" :disabled="!selected.length" @click="print()" variant="outline-secondary">
                        <b-icon-printer></b-icon-printer>
                        <span class="ml-2 mr-1">Print</span>
                    </b-button>
                    <b-button v-if="selected.length < rowCount" @click="selectAll()" variant="outline-secondary">
                        <b-icon-list-check></b-icon-list-check>
                        <span class="ml-2 mr-1">Select All</span>
                    </b-button>
                    <b-button v-else-if="selected.length > 0" @click="clearSelected()" variant="outline-secondary">
                        <b-icon-list></b-icon-list>
                        <span class="ml-2 mr-1">Clear Selected</span>
                    </b-button>
                    <b-button v-if="rowCount > 0" :pressed.sync='selectRange'  @click="setSelectRange()" variant='outline-secondary'>
                      <b-icon-check v-if="selectRange"></b-icon-check> 
                      <b-icon-list v-else></b-icon-list>
                        <span class="ml-2 mr-1">Select Range</span>
                    </b-button>

                    <b-button @click="addOrder()" variant="outline-secondary" size="sm" :disabled="busy">
                        <b-icon-plus></b-icon-plus>
                        <span class="ml-2 mr-1">New Order</span>
                    </b-button>
                    <b-button v-if="shouldShowCreateCustomer" @click="createCustomerFromOrder()" variant="outline-secondary" size="sm" :disabled="busy">
                        <b-icon-person-plus></b-icon-person-plus>
                        <span class="ml-2 mr-1">Create Customer</span>
                    </b-button>
                    <b-button :disabled="!selected.length" @click="previewInvoice()" variant="outline-secondary" size="sm">
                        <b-icon-envelope></b-icon-envelope>
                        <span class="ml-2 mr-1">Preview</span>
                    </b-button>
                    <b-button :disabled="!selected.length" @click="sendInvoice()" variant="outline-secondary" size="sm">
                        <b-icon-receipt></b-icon-receipt>
                        <span class="ml-2 mr-1">Invoice</span>
                    </b-button>
                    <b-button :disabled="!selected.length" @click="pullList()" variant="outline-secondary" size="sm">
                        <b-icon-list-ul></b-icon-list-ul>
                        <span class="ml-2 mr-1">Pull List</span>
                    </b-button>
                    <b-button @click="refresh()" variant="outline-secondary" size="sm">
                        <b-icon-arrow-repeat></b-icon-arrow-repeat>
                        <span class="ml-2 mr-1">Refresh</span>
                    </b-button>
                    <b-button :disabled="!selected.length" @click="removeCombined()" variant="outline-secondary" size="sm">
                        <b-icon-flag></b-icon-flag>
                        <span class="ml-2 mr-1">Remove Combined</span>
                    </b-button>
                </b-button-group>
                <div class="counts">{{ countText }} <span v-if="selected.length > 0" class="ml-5 text-secondary">{{ selected.length }} selected</span></div>               
            </b-button-toolbar>
          
        </b-col>

    </b-row>
</template>

<script>
    export default {
        name: "OrderMenu",
        props: [ 'selected', 'rowCount', 'selectRange', 'showPrintButton', 'busy' ],
        data() {
        return {
            showPrint: this.showPrintButton !== undefined ? this.showPrintButton : true
            }
        },
        methods: {
            selectAll() {
                this.$emit('selectAll');
            },
            clearSelected() {
                this.$emit('clearSelected');
            },
            print() {
                this.$emit('printSelected');
            },
            addOrder() {
                this.$emit('newOrder');
            },
            previewInvoice() {
                this.$emit('previewInvoice');
            },
            sendInvoice() {
                this.$emit('sendInvoice');
            },
            setSelectRange() {
                this.$emit('setSelectRange')
            },
            refresh() {
                this.$emit('refresh');
            },
            createCustomerFromOrder() {
                this.$emit('createCustomerFromOrder');
            },
            pullList() {
                this.$emit('pullList');
            },
            removeCombined() {
                this.$emit('removeCombined');
            }
        },
        computed: {
            countText() {
                if (parseInt(this.rowCount) === 1) {
                    return `${this.rowCount} order`;
                }

                return `${this.rowCount} orders`;
            },
            shouldShowCreateCustomer() {
                // Show button only if exactly one order is selected and it has no customer ID
                if (this.selected.length !== 1) {
                    return false;
                }
                
                const order = this.selected[0];
                const customer = order?.customer;
                
                // Check if customer exists and has no customerId
                return customer && !customer.customerId;
            }
        }
    }
</script>

<style scoped>
    .counts {
        padding: 3px 0;
        margin-left: 40px;
        margin-bottom: 15px;
        display: flex;
        flex-grow: 1;
    }
</style>